import { composeReducers } from 'common/util/composeReducers';
import lodash from 'lodash';

import {
    SORT_TASKS,
    SET_TASK_SORTING_OPTIONS,
    LOAD_ALL_TASKS,
    TASKS_LOADING,
    GET_ALL_TASKS,
    GET_PENDING_EVENT_TASKS,
    GET_COMPLETED_EVENT_TASKS,
    GETTING_PENDING_EVENT_TASKS,
    GETTING_COMPLETED_EVENT_TASKS,
    GET_PENDING_DOA_TASKS,
    GET_COMPLETED_DOA_TASKS,
    GETTING_PENDING_DOA_TASKS,
    GETTING_COMPLETED_DOA_TASKS,
    CLEAR_BINDER_TASKS,
} from 'pages/binder/actions/binderActions';

import { assignTasksByCategory, } from 'common/util/taskHelper';

export function loadAllTasks(state, action) {
    if(!action || action.type !== GET_ALL_TASKS){
        return state;
    }
    return {
        ...state,
        binder : {
            ...state.binder,
            tasks : action.payload
        }
    };
}

export function clearBinderTasks(state, action) {
    if(!action || action.type !== CLEAR_BINDER_TASKS){
        return state;
    }
    return {
        ...state,
        binder : {
            ...state.binder,
            tasksIsLoading : lodash.get(state , 'binder.tasksIsLoading', false ),
            pendingEventsIsLoading : lodash.get(state, 'binder.pendingEventsIsLoading', false),
            completedEventsIsLoading : lodash.get(state, 'binder.completedEventsIsLoading', false),
            tasks: {},
            events: {},
        }
    };
}

export function loadTasksByBinderId(state, action) {
    if(!action || action.type !== LOAD_ALL_TASKS){
        return state;
    }
    let pendingTasks = [], completedTasks = [];
    let tasks = action.payload;

    let sortBy = lodash.get(state, 'binder.taskSortOption.s');
    let order = lodash.get(state, 'binder.taskSortOption.o');
    let format = lodash.get(state, 'binder.taskSortOption.f');

    const tasksWithRecipient = tasks.filter(task => !lodash.isEmpty(task.recipients));
    const tasksWithAssignee = tasksWithRecipient.map(task => {
        const recipientsKeyBySub = lodash.keyBy(task.recipients, 'sub');
        const tasksWithRecipientName=  task.tasks.map(item => {
            const userSub = item.assignee;
            return {
                ...item,
                recipient : recipientsKeyBySub[userSub]
            };
        });
        return {
            ...task,
            tasks : tasksWithRecipientName
        };
    });

    pendingTasks = assignTasksByCategory(tasksWithAssignee, 'Incomplete');
    completedTasks = assignTasksByCategory(tasksWithAssignee, 'Complete');

    pendingTasks = reorderTasks(pendingTasks, sortBy, order, format);
    completedTasks = reorderTasks(completedTasks, sortBy, order, format);

    return {
        ...state,
        binder : {
            ...state.binder,
            tasks : {
                ...state.binder.tasks,
                pending : pendingTasks,
                completed: completedTasks,
            },
            tasksByDocument : orderTasksByDocument(tasksWithAssignee),
        }
    };
}

function orderTasksByDocument(tasks) {
    const documentTasks = {};

    tasks.forEach(task => {
        const documentId = lodash.get(task, 'documentId', lodash.get(task.document, 'id'));
        if (lodash.isNil(documentId) || lodash.eq(task.actionName, 'read_and_acknowledge')) {
            return;
        }


        if (!lodash.hasIn(documentTasks, documentId)) {
            documentTasks[documentId] = {
                tasks: [],
                activeInstances: 0,
            };
        }

        const activeInstances = task.tasks.reduce((acc, task) => {return acc + (!task.finished && !task.deleted ? 1 : 0);}, 0);
        documentTasks[documentId].tasks.push({
            id: task.id,
            status: task.status,
            activeInstances: activeInstances,
        });
        documentTasks[documentId].activeInstances += parseInt(activeInstances);
    });
    return documentTasks;
}

export function gettingPendingBinderEventSignatures(state, action){
    if(!action || action.type !== GETTING_PENDING_EVENT_TASKS){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            pendingEventsIsLoading : action.payload,
        }
    };
}

export function gettingCompletedBinderEventSignatures(state, action){
    if(!action || action.type !== GETTING_COMPLETED_EVENT_TASKS){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            completedEventsIsLoading : action.payload,
        }
    };
}

export function getPendingBinderEventSignatures(state, action){
    if(!action || action.type !== GET_PENDING_EVENT_TASKS){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            events : {
                ...state.binder.events,
                pending : action.payload
            }
        }
    };
}

export function getCompletedBinderEventSignatures(state, action){
    if(!action || action.type !== GET_COMPLETED_EVENT_TASKS){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            events : {
                ...state.binder.events,
                completed : action.payload
            }
        }
    };
}

export function gettingPendingBinderDOASignatures(state, action){
    if(!action || action.type !== GETTING_PENDING_DOA_TASKS){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            pendingDOAsIsLoading: action.payload,
        }
    };
}

export function gettingCompletedBinderDOASignatures(state, action){
    if(!action || action.type !== GETTING_COMPLETED_DOA_TASKS){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            completedDOAsIsLoading: action.payload,
        }
    };
}

export function getPendingBinderDOASignatures(state, action){
    if(!action || action.type !== GET_PENDING_DOA_TASKS){
        return state;
    }

    return {
        ...state,
        binder: {
            ...state.binder,
            delegations: {
                ...state.binder.delegations,
                pending : action.payload
            }
        }
    };
}

export function getCompletedBinderDOASignatures(state, action){
    if(!action || action.type !== GET_COMPLETED_DOA_TASKS){
        return state;
    }

    return {
        ...state,
        binder: {
            ...state.binder,
            delegations: {
                ...state.binder.delegations,
                completed: action.payload
            }
        }
    };
}

export function sortTasks(state, action){
    if(!action || action.type !== SORT_TASKS){
        return state;
    }

    const newState = lodash.clone(state);
    let subpath = action.payload.subpath === ''?  'pending' : action.payload.subpath;

    lodash.set(newState, `binder.tasks.${subpath}`, action.payload.orderedTasks);
    return newState;
}

export function setTaskSortingOptions(state, action){
    if(!action || action.type !== SET_TASK_SORTING_OPTIONS){
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'binder.taskSortOption', action.payload);
    return newState;
}

export function queryingTask(state, action){
    if(!action || action.type !== TASKS_LOADING){
        return state;
    }

    return {
        ...state,
        binder : {
            ...state.binder,
            tasksIsLoading : action.payload,
        }
    };
}

function reorderTasks(tasks, sortBy, order, format){
    if(sortBy, order){
        order = order == -1 ? 'desc': 'asc';
        if(format=='string'){
            tasks = lodash.orderBy(tasks, [item => lodash.get(item, sortBy).toLowerCase()], order);
        }else{
            tasks = lodash.orderBy(tasks, sortBy, order);
        }
    }
    return tasks;
}



export default composeReducers(
    loadAllTasks,
    sortTasks,
    setTaskSortingOptions,
    loadTasksByBinderId,
    queryingTask,
    getPendingBinderEventSignatures,
    getCompletedBinderEventSignatures,
    gettingPendingBinderEventSignatures,
    gettingCompletedBinderEventSignatures,
    getPendingBinderDOASignatures,
    getCompletedBinderDOASignatures,
    gettingPendingBinderDOASignatures,
    gettingCompletedBinderDOASignatures,
    clearBinderTasks,
);
